// The one line of house advertising, for watchers who are not subscribed.
//
// It used to sit at z-index 9000 -- above the player overlay at 3000 -- so it
// hovered over the video you had just opened.

import React from 'react';
import { Box } from '@mui/material';

function Footer() {
  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        width: '100%',
        zIndex: 1100,
        textAlign: 'center',
        py: '6px',
        backgroundColor: 'var(--ps-bg-panel)',
        borderTop: '1px solid var(--ps-line)',
        '& a': {
          fontWeight: 700,
          fontSize: 10.5,
          letterSpacing: 'var(--ps-track)',
          textTransform: 'uppercase',
          color: 'var(--ps-text-2)',
          textDecoration: 'none',
          transition: 'color 130ms cubic-bezier(0.22, 1, 0.36, 1)',
          '&:hover': { color: 'var(--ps-gold)' },
        },
      }}
    >
      <a href="https://philspeiser.com/the_circle" target="_blank" rel="noreferrer">
        Unlock all videos
      </a>
    </Box>
  );
}

export default Footer;
